// src/reducers/groupReducer.js

import {types} from '../types/types';

const initialState = {
    editingGroup: {
        id: 0,
        name: '',
        realmFk: '',
        description: '',
        status: true,
    },
    editingGroupEntity: {
        entityId: 0,     // Puede ser productFk, paymentMethodFk, etc.
        groupFk: '',
        realmFk: '',
    },
    editingGroupDevice: {
        deviceId: '',
        groupFk: '',
        realmFk: '',
    }
};

export const groupReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.editingGroupInfo:
            return {
                ...state,
                editingGroup: action.payload,
            };

        case types.clearGroupInfo:
            return {
                ...state,
                editingGroup: initialState.editingGroup,
            };

        case types.editingGroupEntityInfo:
            return {
                ...state,
                editingGroupEntity: action.payload,
            };

        case types.clearGroupEntityInfo:
            return {
                ...state,
                editingGroupEntity: initialState.editingGroupEntity,
            };

        case types.editingGroupDeviceInfo:
            return {
                ...state,
                editingGroupDevice: action.payload,
            };

        case types.clearGroupDeviceInfo:
            return {
                ...state,
                editingGroupDevice: initialState.editingGroupDevice,
            };

        default:
            return state;
    }
};